"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDialog = void 0;
var react_1 = __importDefault(require("react"));
var Dialog_1 = require("office-ui-fabric-react/lib/Dialog");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
require("./styles/confirm-dialog.scss");
var VARIANT_ICON = {
    default: 'Info',
    warning: 'Warning',
    error: 'Warning',
    completed: 'Completed',
    success: 'Completed',
};
/**
 * ConfirmDialog
 *
 * Reusable confirmation dialog built on top of Office UI Fabric React's
 * `Dialog`. Supports three visual variants (`default`, `error`, `success`)
 * which drive the top accent border, header icon color, and (for `error`)
 * the destructive primary button color.
 *
 * Prefer using this component indirectly through the `useConfirmDialog`
 * hook, which exposes a promise-based imperative API that mirrors
 * `window.confirm`.
 */
exports.ConfirmDialog = function (_a) {
    var hidden = _a.hidden, title = _a.title, message = _a.message, subText = _a.subText, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, _c = _a.confirmText, confirmText = _c === void 0 ? 'OK' : _c, _d = _a.cancelText, cancelText = _d === void 0 ? 'Cancel' : _d, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    // Compose the title with the variant icon. Using Fabric's built-in title
    // slot (instead of a custom header) keeps the default `DialogType.close`
    // close (×) button and the standard a11y wiring.
    var titleNode = (react_1.default.createElement("span", { className: "ws-confirm-dialog-title" },
        react_1.default.createElement(Icon_1.Icon, { iconName: VARIANT_ICON[variant], className: "ws-confirm-dialog-title-icon" }),
        react_1.default.createElement("span", null, title)));
    var bodyText = subText
        ? ((typeof message === 'string' ? message : '') + " " + (typeof subText === 'string' ? subText : '')).trim()
        : undefined;
    return (react_1.default.createElement(Dialog_1.Dialog, { hidden: hidden, onDismiss: onCancel, dialogContentProps: {
            type: Dialog_1.DialogType.close,
            title: titleNode,
            // When both message and subText are plain strings, use Fabric's
            // subText slot for proper typography; otherwise fall back to the
            // children slot to support ReactNode message content.
            subText: typeof message === 'string' && !subText ? message : bodyText ? bodyText : undefined,
        }, modalProps: {
            isBlocking: false,
            className: "ws-confirm-dialog ws-confirm-dialog--" + variant,
        } },
        typeof message !== 'string' ? react_1.default.createElement("div", { className: "ws-confirm-dialog-body" }, message) : null,
        react_1.default.createElement(Dialog_1.DialogFooter, null,
            react_1.default.createElement(Button_1.PrimaryButton, { onClick: onConfirm, text: confirmText, className: "ws-confirm-dialog-confirm-btn" }),
            react_1.default.createElement(Button_1.DefaultButton, { onClick: onCancel, text: cancelText }))));
};
exports.default = exports.ConfirmDialog;
